import React from 'react';
import { Logo } from 'components';

// eslint-disable-next-line import/no-anonymous-default-export
export const Loading = () => (
  <div className="z-50 fixed top-0 left-0 w-full h-screen bg-background flex items-center justify-center">
    <Logo className="w-72 md:w-96" onClick={() => null} />
  </div>
);
